import Vue from "vue";
import Layout from "./Layout.vue";
import BaseButton from "./BaseButton/Index.vue";
import BaseTimeField from "./BaseTimeField/Index.vue";
import BaseDateField from "./BaseDateField/Index.vue";
import BaseDataTableFilter from "./BaseDataTableFilter/Index.vue";
import BaseDataTable from "./BaseDataTable/Index.vue";
import BaseToolbarItem from "./BaseToolbarItem/Index.vue";
import BaseDropZone from "./BaseDropZone/Index.vue";
import BaseDropZone2 from "./BaseDropZone2/Index.vue";
import BaseInfoHeader from "./BaseInfoHeader/Index.vue";
import BaseTimeRoster from "./BaseTimeRoster/Index.vue";

import "./forms";

Vue.component("layout", Layout);
Vue.component("base-button", BaseButton);
Vue.component("base-date-field", BaseDateField);
Vue.component("base-drop-zone", BaseDropZone);
Vue.component("base-drop-zone-2", BaseDropZone2);
Vue.component("base-info-header", BaseInfoHeader);
Vue.component("base-data-table-filter", BaseDataTableFilter);
Vue.component("base-data-table", BaseDataTable);
Vue.component("base-toolbar-item", BaseToolbarItem);
Vue.component("base-time-field", BaseTimeField);
Vue.component("base-time-roster", BaseTimeRoster);
